<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <img
        :src="'/img/avatars/6.jpg'"
        class="img-avatar" />
    </template>\
    <template slot="dropdown">
      <b-dropdown-item to="/user-profile"><i class="fa fa-user"/>{{ $t('profile') }}</b-dropdown-item>
      <b-dropdown-item to="/change/password"><i class="fa fa-key" /> {{ $t('change_password') }}</b-dropdown-item>
      <b-dropdown-item to="/user-setting"><i class="fa fa-wrench" /> {{ $t('settings') }}</b-dropdown-item>
      <b-dropdown-item href="javascript:void(0)" @click="onlogout"><i class="fa fa-lock" /> {{ $t('logout') }}</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
const AppHeaderDropdown = () => import('@/views/layouts/HeaderDropdown.vue');
export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return { itemsCount: 42 }
  },
  methods: {
    onlogout: () => {
      localStorage.clear();
      window.location = '/login'
    }
  }
}
</script>
